import { useExternalScheduleForm } from '@forms/schedules/external';
import { useToast } from '@hooks/useToast';
import { useTranslation } from 'react-i18next';
import { ExternalScheduleDialog } from '..';
import { ExternalScheduleContactsInputs } from '../inputs/contacts';
import { ExternalScheduleDateInputs } from '../inputs/date';
import { DefaultExternalScheduleDialogProps } from '../types';
import { useRescheduler } from '@contexts/rescheduler';

export default function ExternalScheduleGenericDialog({
  open,
  setOpen,
  completed,
  taskId = '',
  schedule,
  importantTasks,
  jobId = '',
  note,
  name,
  extraComment,
  readOnly,
  scheduleType,
  phoneLayout,
  takenDays,
}: DefaultExternalScheduleDialogProps) {
  const { t } = useTranslation('app');
  const { toast } = useToast();
  const rescheduler = useRescheduler();
  const { form, onSubmit, locked } = useExternalScheduleForm({
    jobId,
    taskId,
    scheduleId: schedule?.id,
    schedule,
    note,
    successHandler: (resp) => {
      form.reset();
      setOpen(false);
      toast({
        title: t(`messages.success.schedule.${schedule?.id ? 'update' : 'create'}`),
      });
      if (!resp || !rescheduler) return;
      const { data: updatedSchedule } = resp;
      rescheduler.appendSavedSchedule(updatedSchedule);
      rescheduler.setState((prev) => ({
        ...prev,
        relatedSchedules: prev.relatedSchedules.map((el) =>
          el.task?.id === updatedSchedule.task?.id ? updatedSchedule : el,
        ),
      }));
    },
  });

  return (
    <ExternalScheduleDialog
      type="generic"
      open={open}
      setOpen={setOpen}
      completed={completed}
      form={form}
      onSubmit={onSubmit}
      locked={locked}
      jobId={jobId}
      taskId={taskId}
      schedule={schedule}
      note={note}
      name={name}
      extraComment={extraComment}
      importantTasks={importantTasks}
      readOnly={readOnly}
      scheduleType={scheduleType}
      phoneLayout={phoneLayout}
      takenDays={takenDays}
      whenDisabled={completed || readOnly}>
      {!phoneLayout && <ExternalScheduleDateInputs disabled={completed || readOnly} />}
      <ExternalScheduleContactsInputs
        disabled={readOnly}
        jobId={jobId}
        initialContactId={schedule?.contact?.id}
        open={open}
      />
    </ExternalScheduleDialog>
  );
}
